import moment from 'moment';
import { applyTimeZone } from "../../../utils/utils";

export const MODELS_EVENT_ID = 999999;

export const isModelEventId = eventId => parseInt(eventId, 10) === MODELS_EVENT_ID;

export const findEventById = (events, eventId) => (events || [])
    .find(event => parseInt(event.id, 10) === parseInt(eventId, 10));

export const getEventStart = event => event?.['data-esperada-inici']
    ? applyTimeZone(event['data-esperada-inici'])
    : null;

export const getEventEnd = event => event?.['data-esperada-fi']
    ? applyTimeZone(event['data-esperada-fi'])
    : null;

export const sortEventsByStart = events => [...(events || [])]
    .sort((a, b) => {
        const aStart = getEventStart(a);
        const bStart = getEventStart(b);

        if (!aStart && !bStart) return 0;
        if (!aStart) return 1;
        if (!bStart) return -1;

        return aStart.diff(bStart);
    });

export const isCurrentOrFutureEvent = (event, now = moment()) => {
    const end = getEventEnd(event);
    const start = getEventStart(event);

    if (end) return !end.isBefore(now);
    return start ? !start.isBefore(now) : false;
};

export const getTargetChooserEvents = (events, selectedEvent, now = moment()) => {
    const sortedEvents = sortEventsByStart(events)
        .filter(event => !isModelEventId(event.id));

    if (isModelEventId(selectedEvent)) {
        return sortedEvents.filter(event => isCurrentOrFutureEvent(event, now));
    }

    const selectedEventInfo = findEventById(events, selectedEvent);
    const selectedEventStart = getEventStart(selectedEventInfo);

    return selectedEventStart ? sortedEvents
        .filter(event => {
            const start = getEventStart(event);
            return start ? start.isAfter(selectedEventStart) : false;
        })
        : [];
};

export const isTargetEventValid = (event, now = moment()) =>
    event ? isCurrentOrFutureEvent(event, now) : false;

export const getNextTargetActuacio = (targetEvents, now = moment()) => sortEventsByStart(targetEvents)
    .filter(event => event.tipus === 'actuació')
    .filter(event => isCurrentOrFutureEvent(event, now))
    [0] || null;
